import { FC } from 'react';
import { useURLParameters } from 'hooks';
import {
  ShiftBlockOrdersDataProvider,
  useShiftBlockOrdersDataContext,
} from 'modals/ShiftModal/components/ShiftBlockOrdersList';

export const AwardShiftBlockDataProvider: FC = ({ children }) => {
  const [{ shiftModalShiftId }] = useURLParameters<{ shiftModalShiftId?: string }>();

  if (!shiftModalShiftId) return <>{children}</>;

  return (
    <ShiftBlockOrdersDataProvider orderRelayId={shiftModalShiftId}>
      {children}
    </ShiftBlockOrdersDataProvider>
  );
};

export const useAwardShiftBlockDataContext = useShiftBlockOrdersDataContext;
